import { Typography, Grid, Divider, List, ListItem } from '@mui/material';

import { Link } from 'components';
import { AssociatedEntity, Organization } from 'components/Labels';
import { getFullUserNameOrId } from 'helpers';
import { OrganizationVerboseProps } from 'types';

import { ChildEdit } from '../ChildEdit';
import { OrganizationRemove } from '../OrganizationRemove';

type OrganizationEditProps = {
  setOrganization: React.Dispatch<
    React.SetStateAction<OrganizationVerboseProps>
  >;
  organization: OrganizationVerboseProps;
};

export const OrganizationEdit = (props: OrganizationEditProps) => {
  const { setOrganization, organization } = props;
  const { children, id, users } = organization;
  return (
    <Grid container>
      <Grid item sx={{ mt: 2 }} xs={10}>
        <Typography variant='body2'>
          Add or remove Employers to associate them with this <Organization />.
          Users assigned to this group will have access to all data associated
          with the <Organization /> and <AssociatedEntity />.
        </Typography>
      </Grid>
      <Grid item xs={2} />
      <Grid spacing={2} container sx={{ mt: 2, minHeight: '400px' }}>
        <Grid item xs={5.75}>
          <Typography sx={{ mr: 0.5 }} variant='body1'>
            Currently <AssociatedEntity /> : <b> {children.length} total</b>
          </Typography>

          <OrganizationRemove
            org_id={id}
            setOrganization={setOrganization}
            organizations={children}
          />
        </Grid>
        <Grid sx={{ m: 0 }} item xs={0.5}>
          <Divider sx={{ marginRight: 'auto' }} orientation='vertical' />
        </Grid>
        <Grid item xs={5.75} sx={{}}>
          <ChildEdit
            org_id={id}
            setOrganization={setOrganization}
            organization={organization}
          />
        </Grid>
        <Grid item xs={12}>
          <List>
            <ListItem>
              <Typography variant='body1'>ASSIGNED USERS:</Typography>
            </ListItem>
            {users.map((user) => {
              return (
                <ListItem key={user.id}>
                  <Link to={`/home/candidate_admin_dashboard/users/${user.id}`}>
                    {getFullUserNameOrId(user)}
                  </Link>
                </ListItem>
              );
            })}
          </List>
        </Grid>
      </Grid>
    </Grid>
  );
};
